import React from 'react'
import { TextField } from '@mui/material'
import { Controller } from 'react-hook-form'
import { useReadonly } from '../../../reusableUtils/useReadonly'

type IReactHookFormTextFieldProps = {
  label: string
  name: string
  placeholder?: string
  type?: string
  multiline?: boolean
  maxRows?: number
  rows?: number
  showHelperError?: boolean
  focused?: React.MutableRefObject<boolean>
  required?: boolean
}
export const ReactHookFormTextFieldStyle = { fullWidth: true, autoComplete: 'off', size: 'small', variant: 'outlined' } as const
const ReactHookFormTextField = ({ label, name, placeholder, type, multiline, maxRows, rows, showHelperError = true, focused, required }: IReactHookFormTextFieldProps) => {
  const isReadonly = useReadonly(name)
  return (
    <Controller
      name={name}
      render={({ field, fieldState: { error } }) => (
        <TextField
          placeholder={placeholder}
          onFocus={() => {
            if (focused) focused.current = true
          }}
          {...field}
          onBlur={() => {
            field.onBlur()
            if (focused) focused.current = false
          }}
          label={label}
          error={error !== undefined}
          helperText={(showHelperError && error?.message) ?? ''}
          type={type}
          multiline={multiline}
          maxRows={maxRows}
          rows={rows}
          disabled={isReadonly}
          required={required}
          InputLabelProps={{
            shrink: true // Forces the label to always float
          }}
          size='medium'
          sx={{
            width: '100%',
            borderRadius: '100px',
            '& .MuiInputLabel-root': {
              fontSize: '16px',
              fontWeight: 400,
              color: '#17181B',
              backgroundColor: '#fff',
              px: 0.5
            }
          }}
        />
      )}
    />
  )
}

export default ReactHookFormTextField
